import { render, staticRenderFns } from "./ModalInsuranceTherapies.vue?vue&type=template&id=7a60a11e&"
import script from "./ModalInsuranceTherapies.vue?vue&type=script&lang=js&"
export * from "./ModalInsuranceTherapies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports